import React from 'react';
import { Page } from 'components/layouts/components';
import { Flex } from 'antd';
import TrafficReportingOverview from './components/TrafficReportingOverview';
import EventsOverviewTable from 'modules/ReportModule/components/EventsOverview/EventsOverviewTable';
import FrequentPagesTable from './components/FrequentPagesTable';
import TrafficRepotByPeriod from './components/TrafficRepotByPeriod';
import useQueryParams from 'hooks/useQueryParams';
import JourneyReport from 'modules/ReportModule/context/JourneyReport';
import useWorkspace from 'store/redux/hooks/useWorkspace';
import TrafficReportingReferrers from './components/TrafficReportingReferrers';
import TrafficReportingSources from './components/TrafficReportingSources';

const WebsiteTrafficReporting = () => {
  const { workspace } = useWorkspace();
  const selected_website_id = localStorage.getItem(`selected_website_id_${workspace.id}`);

  const { searchParams } = useQueryParams();
  const { website_id } = searchParams;

  return (
    <Page className='relative'>
      <Flex vertical gap='large'>
        <JourneyReport date_key='trafficReportingOverview'>
          <TrafficReportingOverview />
        </JourneyReport>
        <JourneyReport date_key='traffic-by-period'>
          <TrafficRepotByPeriod />
        </JourneyReport>
        {(website_id || selected_website_id) && (
          <>
            <JourneyReport date_key='getReferrers' title='Referrers'>
              <TrafficReportingReferrers />
            </JourneyReport>
            {/* <JourneyReport date_key='getSources' title='Sources'>
              <TrafficReportingSources />
            </JourneyReport> */}
            <JourneyReport title='Events Overview' date_key='eventsOverview'>
              <EventsOverviewTable />
            </JourneyReport>
            {/* <JourneyReport title='Most Viewed Pages by Period' date_key='frequentPages'>
              <FrequentPagesTable />
            </JourneyReport> */}
          </>
        )}
      </Flex>
    </Page>
  );
};

export default WebsiteTrafficReporting;
